import React, { useState, useEffect, Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import AuthModal from './components/AuthModal';
import DashboardSidebar from './components/DashboardSidebar';
import MessageFab from './components/MessageFab';
import UserChat from './components/UserChat';   // ← new
import { LanguageProvider } from './context/LanguageContext';
import { AuthProvider, useAuth } from './context/AuthContext';
import BackgroundWrapper from './components/BackgroundWrapper';
import mainBackground from './assets/images/02.png';
import homeBackground from './assets/images/01.png';

import './styles/global.css';import './styles/responsive.css';


// Lazy load pages for better performance
const Home = lazy(() => import('./pages/Home'));
const About = lazy(() => import('./pages/About'));
const Designs = lazy(() => import('./pages/Designs'));

function Layout() {
  const { user } = useAuth();
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  const [showAuth, setShowAuth] = useState(false);
  const [showChat, setShowChat] = useState(false);   // user chat

  useEffect(() => {
    // Preload background images for faster loading
    const preloadImages = [mainBackground, homeBackground];
    preloadImages.forEach(src => {
      const img = new Image();
      img.src = src;
    });
  }, []);

  useEffect(() => {
    const contentWrapper = document.querySelector('.content-wrapper');
    if (contentWrapper) {
      contentWrapper.style.backgroundImage = `url(${isHomePage ? homeBackground : mainBackground})`;
    }
  }, [isHomePage]);

  return (
    <div className={`app-container ${user?.role === 'admin' ? 'admin' : ''}`}>
      <Navbar openAuth={() => setShowAuth(true)} />

      <div className="content-wrapper">
        {user?.role === 'admin' && <DashboardSidebar />}

        <BackgroundWrapper>
          <main className="main-content">
            <Suspense fallback={<div className="loading-spinner">Loading...</div>}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/designs" element={<Designs />} />
              </Routes>
            </Suspense>
          </main>
        </BackgroundWrapper>
      </div>

      <Footer />

      {showAuth && <AuthModal onClose={() => setShowAuth(false)} />}

      {/*  USER CHAT  –  only for logged-in users  */}
      {user?.role === 'user' && (
        <>
          <MessageFab onClick={() => setShowChat(true)} />
          {showChat && <UserChat onClose={() => setShowChat(false)} />}
        </>
      )}
    </div>
  );
}

export default function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
          <Layout />
        </BrowserRouter>
      </AuthProvider>
    </LanguageProvider>
  );
}

